import { CategoryDataType } from '@recone/models';
import { AxiosInstance, AxiosResponse } from 'axios';
import config from '../../config';

const TEAM_PROFILE_BASE_PATH = `${config.service.BASE_URL}/crawled-accounts`;
const ASSIGN_TO_PROJECT = 'crawled-accounts/assignToProject';
const FILTER_AND_ASSIGN_TO_PROJECT = 'crawled-accounts/filter-and-assign';
const COPY_ALL_TO_PROJECT = `${TEAM_PROFILE_BASE_PATH}/copyAll`;
const REMOVE_MANY_FROM_PROJECT = 'crawled-accounts/removeManyFromProject';
const ADD_NOTES_PATH = 'crawled-accounts/add-notes';

export const assignToSavedTab = (
  axiosInstance: AxiosInstance,
  accountIds: string | string[],
  projectId: string
): Promise<AxiosResponse<boolean>> =>
  axiosInstance.post(`${config.service.BASE_URL}/${ASSIGN_TO_PROJECT}`, { projectId, accountIds });

export const assignFilteredToSavedTab = (
  axiosInstance: AxiosInstance,
  filters: CategoryDataType[],
  sourceProjectId: string,
  targetProjectId: string
): Promise<AxiosResponse<boolean>> =>
  axiosInstance.post(`${config.service.BASE_URL}/${FILTER_AND_ASSIGN_TO_PROJECT}`, {
    sourceProjectId,
    targetProjectId,
    filters
  });

export const removeFromProject = (
  axiosInstance: AxiosInstance,
  projectId: string,
  ids: string[]
): Promise<AxiosResponse<boolean>> =>
  axiosInstance.post(`${config.service.BASE_URL}/${REMOVE_MANY_FROM_PROJECT}`, { projectId, profileIds: ids });

export const addNotesToProfile = (
  axiosInstance: AxiosInstance,
  profileId: string,
  projectId: string,
  notes: string
): Promise<AxiosResponse<{ message: string; success: boolean }>> =>
  axiosInstance.post(`${config.service.BASE_URL}/${ADD_NOTES_PATH}`, { profileId, projectId, notes });

export const copyAllToProject = (
  axiosInstance: AxiosInstance,
  sourceProjectId: string,
  targetProjectId: string
): Promise<AxiosResponse<boolean>> => axiosInstance.post(COPY_ALL_TO_PROJECT, { targetProjectId, sourceProjectId });
